

export const initialPage = 1
export const initialPageSize = 15
